import React, { useState, useEffect } from "react";
import { Sparkles, Lightbulb, TrendingUp, Eye, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const sampleTips = [
  {
    title: "Ad Placement Adjustment",
    description: "Move your top-performing ad unit above-the-fold to increase viewability by 18%.",
    icon: <TrendingUp className="w-5 h-5 text-green-500" />,
  },
  {
    title: "Experiment with Formats",
    description: "Try switching to sticky banner ads — AI predicts 12% better CTR for your layout.",
    icon: <Lightbulb className="w-5 h-5 text-yellow-500" />,
  },
  {
    title: "Lazy Load Optimization",
    description: "Enable lazy loading to improve mobile speed. AI suggests reducing load time by 25%.",
    icon: <Sparkles className="w-5 h-5 text-indigo-500" />,
  },
  {
    title: "Viewability Alert",
    description: "Your sidebar ad unit has < 40% visibility. Consider resizing or repositioning.",
    icon: <Eye className="w-5 h-5 text-blue-500" />,
  },
];

const AIOptimizationTips = () => {
  const [tips, setTips] = useState(sampleTips);

  const dismissTip = (index) => {
    const updated = [...tips];
    updated.splice(index, 1);
    setTips(updated);
  };

  return (
    <motion.div
      className="bg-white rounded-2xl p-6 shadow-xl border border-gray-200"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        <Sparkles className="text-indigo-500" /> AI Optimization Tips
      </h2>

      <div className="space-y-4">
        <AnimatePresence>
          {tips.map((tip, idx) => (
            <motion.div
              key={idx}
              className="flex items-start justify-between p-4 bg-gray-50 rounded-lg shadow-sm border border-gray-100"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <div className="flex gap-3">
                <div className="mt-1">{tip.icon}</div>
                <div>
                  <h4 className="text-md font-semibold text-gray-700">
                    {tip.title}
                  </h4>
                  <p className="text-sm text-gray-600">{tip.description}</p>
                </div>
              </div>
              <button
                onClick={() => dismissTip(idx)}
                className="ml-3 text-gray-400 hover:text-red-500"
                aria-label="Dismiss"
              >
                <X className="w-4 h-4" />
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default AIOptimizationTips;
